export default __webpack_public_path__ + "static/media/personalDetailshelp@2x.90d07c3b.png";